import { EqlFieldValueType, QueryBuilderGroupOption } from 'generated/graphql';
import FilterValue from 'v2/querybuilder/types/filtervalue';

export function getFilterValueFromSuggestion(
  option: QueryBuilderGroupOption,
): FilterValue {
  const { valueType, isMultiValue } = option.field;
  const value = option.value?.value;

  switch (valueType) {
    case EqlFieldValueType.String:
      return isMultiValue
        ? {
            type: 'string[]',
            values: Array.isArray(value)
              ? value
                  .filter((value) => !!value)
                  .map((value) => ({
                    type: 'string',
                    value: value ? String(value) : '',
                  }))
              : value
              ? [
                  {
                    type: 'string',
                    value: String(value),
                  },
                ]
              : [],
          }
        : {
            type: 'string',
            value: value ? String(value) : undefined,
          };
    case EqlFieldValueType.Number:
      return isMultiValue
        ? {
            type: 'number[]',
            values: Array.isArray(value)
              ? value
                  .filter((value) => !!value)
                  .map((value) => ({
                    type: 'number',
                    value: Number(value),
                  }))
              : value
              ? [
                  {
                    type: 'number',
                    value: Number(value),
                  },
                ]
              : [],
          }
        : {
            type: 'number',
            value: value ? Number(value) : undefined,
          };
    case EqlFieldValueType.Boolean:
      return isMultiValue
        ? {
            type: 'boolean[]',
            values: Array.isArray(value)
              ? value
                  .filter((value) => !!value)
                  .map((value) => ({
                    type: 'boolean',
                    value: Boolean(value),
                  }))
              : value
              ? [
                  {
                    type: 'boolean',
                    value: Boolean(value),
                  },
                ]
              : [],
          }
        : {
            type: 'boolean',
            value: value ? Boolean(value) : undefined,
          };
    default:
      return {
        type: 'string',
        value,
      };
  }
}
